export const SLIDER_TYPE = {
    INSPECTION: 'inspection',
    OLX_AUTOS: 'olx_autos'
};

export const SHOW_MAX = {
    INSPECTION: 3,
    OLX_AUTOS: 3
};

export const LISTING = 'listing';
export const HOME = 'home';
